import {PureComponent} from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import './SearchCard.scss'

export default class SearchCard extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    link: PropTypes.string.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
      <div className={`col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4 pr-3 pl-3 search-card ${this.props.className}`}>
        <Link className="h-100" to={this.props.link}>
          {this.props.children}
        </Link>
      </div>
    )
  }
}